import { createFileRoute } from "@tanstack/react-router";
import { MeteoClimateActionPage } from "@/components/meteo-climate-action-page";

export const Route = createFileRoute("/climate-action")({
  head: () => ({
    meta: [
      { title: "Climate Action for Kenyan Farmers | Meteo Climate Intelligence" },
      {
        name: "description",
        content:
          "Meteo Climate Action delivers AI-assisted climate insights, drought monitoring and agricultural advisories for Kenyan farmers across all 47 counties. Check local climate conditions now.",
      },
      { name: "robots", content: "index, follow" },
      {
        tagName: "link",
        rel: "canonical",
        href: "https://meteo.co.ke/climate-action",
      },
      {
        property: "og:title",
        content:
          "Climate Action for Kenyan Farmers | Meteo Climate Intelligence",
      },
      {
        property: "og:description",
        content:
          "Meteo Climate Action delivers AI-assisted climate insights, drought monitoring and agricultural advisories for Kenyan farmers across all 47 counties.",
      },
      { property: "og:url", content: "https://meteo.co.ke/climate-action" },
      { property: "og:type", content: "website" },
    ],
  }),
  component: MeteoClimateActionPage,
});
